export const environment = {
  production: false,
};
export const SERVER_URL = "https://www.uneda.com/api/";
export const IS_WEB = true;